import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL_BASE + "api/auth/";

class AuthService {
  login(email, password, rememberMe = true) {
    return axios
      .post(API_URL + "signin", {
        email,
        password,
        rememberMe,
      })
      .then((response) => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));

          // Auto-select first store if user has stores
          if (response.data.stores && response.data.stores.length > 0) {
            const saved = localStorage.getItem("activeStoreId");
            // Keep existing selection if it's still valid
            const validIds = response.data.stores.map((s) => s._id);
            if (!saved || !validIds.includes(saved)) {
              localStorage.setItem("activeStoreId", response.data.stores[0]._id);
            }
          }
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password,
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }
}

export default new AuthService();
